import api from "../../../api";

export default {
  async deleteAlerts({ commit, rootState }, ids) {
    const isAdmin = () => rootState.auth?.mySelf?.roles?.includes('admin') === true;
    if (!isAdmin()) throw new Error('Nur Administratoren dürfen Alerts mehrfach löschen.');
    const selectedIds = [...new Set((Array.isArray(ids) ? ids : []).filter(id => typeof id === 'string' && id.length > 0))];
    const deletedIds = [], failedIds = [];
    if (!selectedIds.length) return { deletedIds, failedIds };
    commit('REQUEST_DELETE_ALERT');
    commit('SET_LOADING', true, { root: true });
    try {
      // Reuse the existing admin-authorized soft-delete endpoint, with bounded
      // concurrency. Failed records remain in the shared list and can be retried.
      for (let offset = 0; offset < selectedIds.length; offset += 4) {
        if (!isAdmin()) {
          failedIds.push(...selectedIds.slice(offset));
          break;
        }
        await Promise.all(selectedIds.slice(offset, offset + 4).map(async id => {
          if (!isAdmin()) { failedIds.push(id); return; }
          try {
            await api.deleteAlert(id);
            deletedIds.push(id);
          } catch (error) {
            failedIds.push(id);
            if (error.status === 401) commit('TO_LOGIN', true, { root: true });
          }
        }));
      }
      commit('SUCCESS_DELETE_ALERTS', deletedIds);
      if (failedIds.length) commit('FAILURE_DELETE_ALERT');
      return { deletedIds, failedIds };
    } finally {
      commit('SET_LOADING', false, { root: true });
    }
  },
  async getAlerts({ commit }) {
    commit("REQUEST_ALERTS");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_ALERTS",
        await api.getAlerts()
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_ALERTS");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async deleteAlert({ commit }, id) {
    commit("REQUEST_DELETE_ALERT");
    commit("SET_LOADING", true, { root: true });
    try {
      await api.deleteAlert(id);
      commit("SUCCESS_DELETE_ALERT", id);
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_DELETE_ALERT");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }


};
